var map = {
	"./authentication/authentication.module": [
		"./src/app/authentication/authentication.module.ts",
		"default~authentication-authentication-module~module-main-module",
		"common",
		"authentication-authentication-module"
	],
	"./module/authentication/ms.module": [
		"./src/app/module/authentication/ms.module.ts",
		"common",
		"module-authentication-ms-module"
	],
	"./module/main.module": [
		"./src/app/module/main.module.ts",
		"default~authentication-authentication-module~module-main-module",
		"common",
		"module-main-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;